import { Box, Container, Grid, Typography, Link, Divider, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import BoltIcon from '@mui/icons-material/Bolt';
import { useNavigate } from 'react-router-dom';

const FooterContainer = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.grey[900],
    color: theme.palette.common.white,
    padding: theme.spacing(12, 0, 6, 0),
    [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(8, 0, 4, 0),
    },
    marginTop: 'auto',
}));

const LogoSection = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    color: theme.palette.primary.light,
}));

const FooterLink = styled(Link)(({ theme }) => ({
    color: theme.palette.grey[400],
    textDecoration: 'none',
    display: 'block',
    marginBottom: theme.spacing(1.5),
    transition: 'color 0.2s',
    cursor: 'pointer',
    '&:hover': {
        color: theme.palette.primary.light,
    },
}));

const SocialIconButton = styled(IconButton)(({ theme }) => ({
    color: theme.palette.grey[400],
    padding: theme.spacing(1),
    marginRight: theme.spacing(1),
    '&:hover': {
        color: theme.palette.primary.light,
        backgroundColor: 'rgba(255, 255, 255, 0.05)',
    },
}));

const Footer = () => {
    const navigate = useNavigate();
    const currentYear = new Date().getFullYear();

    return (
        <FooterContainer component="footer">
            <Container maxWidth="lg">
                <Grid container spacing={4}>
                    {/* Brand Section */}
                    <Grid item xs={12} md={12} sx={{ mb: { xs: 6, md: 0 } }}>
                        <LogoSection>
                            <BoltIcon sx={{ mr: 1, color: '#FFD700', fontSize: 28 }} />
                            <Typography variant="h6" sx={{ fontWeight: 800, letterSpacing: '0.05em' }}>
                                EVBuddy
                            </Typography>
                        </LogoSection>
                        <Typography variant="body2" sx={{ color: 'grey.400', mb: 3, maxWidth: '320px', lineHeight: 1.8 }}>
                            The UK&apos;s ultimate companion for electric vehicle drivers. Discover thousands of public charging points and plan your journey with confidence.
                        </Typography>
                    </Grid>

                    {/* Quick Links */}
                    <Grid item xs={6} md={2} sx={{ mb: { xs: 4, md: 0 } }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 3, color: 'white' }}>
                            Explore
                        </Typography>
                        <FooterLink onClick={() => navigate('/')}>Home</FooterLink>
                        <FooterLink onClick={() => navigate('/map')}>Search Map</FooterLink>
                        <FooterLink href="/sitemap.xml">Sitemap</FooterLink>
                    </Grid>

                    {/* Who We Help */}
                    <Grid item xs={6} md={2} sx={{ mb: { xs: 4, md: 0 } }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 3, color: 'white' }}>
                            Who We Help
                        </Typography>
                        <FooterLink onClick={() => navigate('/drivers')}>Drivers</FooterLink>
                        <FooterLink>Businesses</FooterLink>
                        <FooterLink>Government</FooterLink>
                    </Grid>
                </Grid>

                <Divider sx={{ my: 6, borderColor: 'rgba(255, 255, 255, 0.1)' }} />

                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: 2
                }}>
                    <Typography variant="body2" sx={{ color: 'grey.500' }}>
                        © {currentYear} EVBuddy. All rights reserved. A project built with ❤️ by Daz Software Ltd.
                    </Typography>
                </Box>
            </Container>
        </FooterContainer>
    );
};

export default Footer;
